// extracted by mini-css-extract-plugin
export default {"header":"niK4U","hidden":"YOaq3","visible":"RYERe"};